/* eslint-disable prettier/prettier */
const translations = {
    en: {
        navbar: {
            title: "Sri Amba Bhavani Temple",
            home: "Home",
            pooje: "Hunnime Pooja",
            donations: "Donations",
        },
        home: {
            title: "Sri Amba Bhavani Temple",
            subtitle: "Sri Kshetra Hulikere, Kadur Taluk, Chikkamagaluru District",
            galleryTitle: "Temple Photo Gallery",
            galleryDesc: "View and download photos of temple poojas and special moments.",
            galleryBtn: "Open Gallery",
            youtubeTitle: "Temple YouTube Channel",
            youtubeDesc: "Subscribe to watch poojas and special events videos.",
            youtubeBtn: "Open Channel",
            mapTitle: "Temple Location",
        },
        hunnimepooje: {
            title: "🌕 Full Moon Pooja Details",
            sponsorsLabel: "🙏 Sponsors",
            timeLabel: "⏰ Time ",
            brief: "By the grace of our family deity, Shri Amba Bhavani, special Abhisheka and pooja are performed on every full moon day. We sincerely thank the donors supporting Annadasoha and pray for Mother Amba Bhavani’s blessings of health and prosperity upon them and their families.",
            days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        },
        donations: {
            headerText: "🙏 On behalf of the committee, we thank all devotees for their support and pray that Shri Amba Bhavani blesses them and their families with continued goodwill, prosperity, and well-being.",
            allYears: "All Years",
            searchOpt: "Searchh By Donar Name",
            printOpt: "Print",
            serialNo: "Serial No",
            yearField: "Year ",
            devoteeName: "Donar Name",
            donation: "Donation",
            amount: "Amount (₹)",
            totalAmount: "Total Amount (₹)",

        },

    },
    kn: {
        navbar: {
            title: "ಶ್ರೀ ಅಂಬಾ ಭವಾನಿ ದೇವಾಲಯ",
            home: "ಮುಖಪುಟ",
            pooje: "ಹುಣ್ಣಿಮೆ ಪೂಜೆ",
            donations: "ದೇಣಿಗೆ ವಿವರ",
        },
        home: {
            title: "ಶ್ರೀ ಅಂಬಾ ಭವಾನಿ ದೇವಾಲಯ",
            subtitle: "ಶ್ರೀ ಕ್ಷೇತ್ರ ಹುಲಿಕೆರೆ, ಕಡೂರು ತಾಲೂಕು, ಚಿಕ್ಕಮಗಳೂರು ಜಿಲ್ಲೆ",
            galleryTitle: "ದೇವಾಲಯದ ಫೋಟೋ ಗ್ಯಾಲರಿ",
            galleryDesc: "ದೇವಾಲಯದ ಪೂಜೆಗಳ ಮತ್ತು ವಿಶೇಷ ಕ್ಷಣಗಳ ಫೋಟೋಗಳನ್ನು ಇಲ್ಲಿ ನೋಡಬಹುದು.",
            galleryBtn: "ಗ್ಯಾಲರಿ ತೆರೆಯಿರಿ",
            youtubeTitle: "ದೇವಾಲಯದ ಯೂಟ್ಯೂಬ್ ಚಾನೆಲ್",
            youtubeDesc: "ಪೂಜೆಗಳ ಮತ್ತು ವಿಶೇಷ ಕ್ಷಣಗಳ ವಿಡಿಯೋಗಳನ್ನು ನೋಡಲು ಚಾನೆಲ್ ಸಬ್ ಸ್ಕ್ರೈಬ್ ಮಾಡಿ.",
            youtubeBtn: "ಚಾನೆಲ್ ತೆರೆಯಿರಿ",
            mapTitle: "ದೇವಾಲಯದ ವಿಳಾಸ",
        },
        hunnimepooje: {
            title: "🌕 ಹುಣ್ಣಿಮೆ ಪೂಜೆಗಳ ವಿವರ",
            sponsorsLabel: "🙏 ಸೇವಾರ್ಥದಾರರು",
            timeLabel: "⏰ ಸಮಯ ",
            brief: "ನಮ್ಮೆಲ್ಲರ ಕುಲದೇವತೆ, ಜಗನ್ಮಾತೆ ಶ್ರೀ ಅಂಬಾ ಭವಾನಿ ಕೃಪಾಶೀರ್ವಾದದಿಂದ ದೇಗುಲದಲ್ಲಿ ವಿಶೇಷವಾಗಿ ಪ್ರತಿ ತಿಂಗಳ ಹುಣ್ಣಿಮೆಯ ದಿನದಂದು ಅಮ್ಮನವರಿಗೆ ಅಭಿಷೇಕ ವಿಶೇಷ ಅಲಂಕಾರ ಪೂಜೆಯೊಂದಿಗೆ ನಡೆಯುತ್ತಿರುವ ಅನ್ನದಾಸೋಹ ಸೇವಾರ್ಥದರರಿಗೆ ಸಮಿತಿ ಪರವಾಗಿ ಧನ್ಯವಾದಗಳು ಹಾಗು ಇವರ ಕುಟುಂಬ ವರ್ಗಕ್ಕೆ ಶ್ರೀ ಅಮ್ಮನವರು ಸನ್ಮಂಗಳವನ್ನುಂಟುಮಾಡಲಿ ಎಂದು ಪ್ರಾರ್ಥಿಸುತ್ತೇವೆ.",
            days: ["ಭಾನುವಾರ", "ಸೋಮವಾರ", "ಮಂಗಳವಾರ", "ಬುಧವಾರ", "ಗುರುವಾರ", "ಶುಕ್ರವಾರ", "ಶನಿವಾರ"],
            months: ["ಜನವರಿ", "ಫೆಬ್ರವರಿ", "ಮಾರ್ಚ್", "ಏಪ್ರಿಲ್", "ಮೇ", "ಜೂನ್", "ಜುಲೈ", "ಆಗಸ್ಟ್", "ಸೆಪ್ಟೆಂಬರ್", "ಅಕ್ಟೋಬರ್", "ನವೆಂಬರ್", "ಡಿಸೆಂಬರ್"],
        },
        donations: {
            headerText: " 🙏 ಸದಾ ಇವರಲ್ಲಿ ಸಹಕಾರ ಮನೋಭಾವ ನೆಲೆಸಿರಲಿ ಎಂದು ಹಾರೈಸುತ್ತಾ ಸಮಿತಿ ಪರವಾಗಿ ಭಕ್ತರ ಸಹಕಾರಕ್ಕೆ ಧನ್ಯವಾದಗಳು, ಇವರ ಕುಟುಂಬ ವರ್ಗಕ್ಕೆ ಶ್ರೀ ಅಮ್ಮನವರು ಸನ್ಮಂಗಳವನ್ನು ಉಂಟು ಮಾಡಲಿ ಎಂದು ಪ್ರಾರ್ಥಿಸುತ್ತೇವೆ.🙏",
            allYears: "ಎಲ್ಲಾ ವರ್ಷಗಳು",
            searchOpt: "ಭಕ್ತರ ಹೆಸರನ್ನು ಹುಡುಕಿ",
            printOpt: "ಪ್ರಿಂಟ್",
            serialNo: "ಕ್ರಮ ಸಂಖ್ಯೆ",
            yearField: "ವರ್ಷ ",
            devoteeName: "ಭಕ್ತರ ಹೆಸರು",
            donation: "ದೇಣಿಗೆ",
            amount: "ಮೊತ್ತ (₹)",
            totalAmount: "ಒಟ್ಟು ಮೊತ್ತ (₹)",

        },

    },
};


export default translations;